module.exports = __webpack_public_path__ + "media/dashboard/assets/logoInterativa-gray-ac50aa6ed34ae6ca709a4bd0e904ca3c.svg";